/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.entities.controllers', [
  'acme.common.service.api',
  'acme.common.service.permissions'
])

.controller('EntitiesController', ['$scope', 'ApiService', 'PermissionsService', function($scope, ApiService, PermissionsService) {

  $scope.entities = {

    emailSetting: 'always',
    emailSettingLabel: '',
    emailSettings: [
      {
        name: 'always',
        label: 'Always'
      },
      {
        name: 'never',
        label: 'Never'
      },
      {
        name: 'ask',
        label: 'Ask to send'
      }
    ],

    resourceEmailLabel: 'Send resource assignment emails:',

    init: function() {
      if (PermissionsService.check('TENANT_ADMINISTRATION_VIEW')) {
        ApiService.administration.detail().then(this.success.init, this.error.init);
      }
    },

    isPeopleResource: function(type) {
      return (type.toLowerCase() === 'personnel');
    },

    getEmailSetting: function(setting) {

      var i, ii,
          r = false;

      for (i=0,ii=this.emailSettings.length;i<ii;i++) {
        if (this.emailSettings[i].name === setting) {
          r = {
            index: i,
            setting: this.emailSettings[i]
          };
        }
      }

      return r;

    },

    success: {
      init: function(response) {
        var found,
          self = $scope.entities;

        if (response.data.payload &&
            response.data.payload.hasOwnProperty('notificationPreference')) {
          self.emailSetting = response.data.payload.notificationPreference;
          found = self.getEmailSetting(self.emailSetting);
          self.emailSettingLabel = found ? found.setting.label : '';
        }
      }
    },

    error: {
      init: function(response) {}
    }

  };

  $scope.entities.init();

}]);